import {
  DefaultCurrencyPickListOptions,
  HeardAboutUsOptions,
  InvestmentExperienceLevel,
} from "src/store/features/api/generated";
import { WealthSourceOptions, AccountPurposeOptions } from "src/store/features/onboarding.slice";

export const supportedCurrencies: { label: string; value: DefaultCurrencyPickListOptions }[] = [
  { label: "AUD", value: "Australian Dollar (AUD)" },
  { label: "EUR", value: "Euro (EUR)" },
  { label: "USD", value: "US Dollar (USD)" },
  { label: "CAD", value: "Canadian Dollar (CAD)" },
  { label: "GBP", value: "British Pound (GBP)" },
  { label: "NZD", value: "New Zealand Dollar (NZD)" },
];

export const referralOptions: HeardAboutUsOptions[] = [
  "Referral Partner / Affiliate",
  "Online - web search",
  "Online - social media",
  "Friend / family",
  "Colleague",
  "Advertisement",
  "News Article",
  "Email",
  "Event",
  "Other",
];

export const frequencyOptions = [
  "Daily",
  "Fortnightly",
  "Monthly",
  "Quarterly",
  "Biannually",
  "Annually",
];

export const accountPurposeOptions: AccountPurposeOptions[] = [
  "Short Term Trading",
  "Long Term Trading",
  "Custody of Assets",
  "Purchase Only",
  "Sell Only",
];

export const experienceOptions: { value: InvestmentExperienceLevel; label: string }[] = [
  { value: "Beginner (0-1 year)", label: "< 1 Year" },
  { value: "Intermediate (2-3 years)", label: "1-3 Years" },
  { value: "Expert (4+ years)", label: "> 4 Years" },
];

export const wealthSourceOptions: { label: string; value: WealthSourceOptions }[] = [
  {
    label: "Income",
    value: "Income",
  },
  {
    label: "Investments",
    value: "Investments",
  },
  { label: "Savings", value: "Savings" },
  { label: "Property Income", value: "Property Income" },
  { label: "Private Pension", value: "Pension" },
  { label: "Inheritance", value: "Inheritance" },
  { label: "Others", value: "Others" },
];
